import React, { useState } from "react";
import { Minus, Plus } from "lucide-react";
import { faqs } from "../mock";

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="relative scroll-mt-28 overflow-hidden bg-[#EDF1F8] px-6 py-24">
      <div className="pointer-events-none absolute left-1/2 top-16 h-64 w-64 -translate-x-1/2 rounded-full bg-white/50 blur-[90px]" />

      <div className="relative mx-auto max-w-[1180px]">
        <div className="text-center">
          <p className="text-xs font-bold uppercase tracking-[0.34em] text-[#5BA4FB]">
            Fragen
          </p>
          <h2 className="mt-5 font-serif text-[11vw] leading-[0.95] tracking-tight text-[#16263F] md:text-[4.8rem]">
            Häufige Fragen
          </h2>
        </div>

        <div className="mt-16 overflow-hidden rounded-[32px] border border-white/70 bg-white/42 shadow-[0_24px_70px_rgba(20,40,70,0.08)] backdrop-blur-xl">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.question}
                className={index === 0 ? "" : "border-t border-[#D8E0EC]/80"}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="flex w-full items-center justify-between gap-6 px-6 py-7 text-left transition-colors duration-200 hover:bg-white/35 md:px-10 md:py-9"
                >
                  <span className="text-[20px] font-semibold leading-snug text-[#16263F] md:text-[26px]">
                    {faq.question}
                  </span>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/80 bg-white/55 text-[#16263F] shadow-[0_8px_24px_rgba(20,40,70,0.07)]">
                    {isOpen ? (
                      <Minus className="h-5 w-5" strokeWidth={2.3} />
                    ) : (
                      <Plus className="h-5 w-5" strokeWidth={2.3} />
                    )}
                  </span>
                </button>

                <div
                  className={`grid transition-[grid-template-rows,opacity] duration-300 ease-out ${
                    isOpen
                      ? "grid-rows-[1fr] opacity-100"
                      : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="max-w-3xl px-6 pb-8 text-[16px] leading-7 text-slate-500 md:px-10 md:pb-10 md:text-[18px]">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
